<template>
    <div class="w-full flex flex-col">
        <div class="flex flex-row justify-between items-center gap-2">
            <div class="flex flex-row items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <g clip-path="url(#clip0_848_24018)">
                        <path
                            d="M8.03965 16.0002C6.93853 16.0002 5.90189 15.7917 4.92972 15.3747C3.95755 14.9577 3.10801 14.3857 2.38112 13.6586C1.65408 12.9317 1.08205 12.0822 0.665053 11.11C0.248052 10.1378 0.0395508 9.10121 0.0395508 8.00009C0.0395508 6.8899 0.248052 5.85099 0.665053 4.88335C1.08205 3.91572 1.65408 3.06846 2.38112 2.34157C3.10801 1.61452 3.95755 1.0425 4.92972 0.625502C5.90189 0.208501 6.93853 0 8.03965 0C9.14984 0 10.1888 0.208501 11.1564 0.625502C12.124 1.0425 12.9713 1.61452 13.6982 2.34157C14.4252 3.06846 14.9972 3.91572 15.4142 4.88335C15.8312 5.85099 16.0397 6.8899 16.0397 8.00009C16.0397 9.10121 15.8312 10.1378 15.4142 11.11C14.9972 12.0822 14.4252 12.9317 13.6982 13.6586C12.9713 14.3857 12.124 14.9577 11.1564 15.3747C10.1888 15.7917 9.14984 16.0002 8.03965 16.0002ZM8.03965 14.8167C8.35643 14.5 8.65343 13.9841 8.93064 13.2689C9.20786 12.5538 9.42091 11.7566 9.56977 10.8775H6.50952C6.66967 11.7792 6.88557 12.5876 7.15722 13.3028C7.42872 14.018 7.72287 14.5226 8.03965 14.8167ZM6.62293 14.7068C6.34453 14.2672 6.09318 13.7139 5.86885 13.0467C5.64453 12.3795 5.47265 11.6564 5.35324 10.8775H1.82155C2.28588 11.893 2.94156 12.737 3.78861 13.4094C4.63565 14.0816 5.58042 14.5141 6.62293 14.7068ZM9.45637 14.7068C10.4989 14.5141 11.4436 14.0816 12.2907 13.4094C13.1377 12.737 13.7934 11.893 14.2577 10.8775H10.7261C10.5784 11.662 10.3923 12.3878 10.168 13.0551C9.94384 13.7224 9.70662 14.2729 9.45637 14.7068ZM1.42242 9.73462H5.24005C5.19947 9.42253 5.17404 9.11681 5.16379 8.81747C5.15368 8.51827 5.14862 8.23116 5.14862 7.95614C5.14862 7.68112 5.15368 7.40133 5.16379 7.11679C5.17404 6.8321 5.19947 6.54836 5.24005 6.26557H1.42242C1.33788 6.54953 1.27678 6.83803 1.23913 7.13107C1.20132 7.42412 1.18242 7.71379 1.18242 8.00009C1.18242 8.2864 1.20132 8.57607 1.23913 8.86912C1.27678 9.16216 1.33788 9.45066 1.42242 9.73462ZM6.40468 9.73462H9.67461C9.71505 9.40788 9.7404 9.10502 9.75065 8.82604C9.76076 8.54706 9.76582 8.27175 9.76582 8.00009C9.76582 7.72844 9.76076 7.44946 9.75065 7.16316C9.7404 6.87686 9.71505 6.57766 9.67461 6.26557H6.40468C6.36424 6.57766 6.33889 6.87686 6.32864 7.16316C6.31853 7.44946 6.31347 7.72844 6.31347 8.00009C6.31347 8.27175 6.31853 8.55072 6.32864 8.83703C6.33889 9.12333 6.36424 9.42253 6.40468 9.73462ZM10.8392 9.73462H14.6569C14.7414 9.45066 14.8025 9.16216 14.8402 8.86912C14.878 8.57607 14.8969 8.2864 14.8969 8.00009C14.8969 7.71379 14.878 7.42045 14.8402 7.12008C14.8025 6.81971 14.7414 6.53488 14.6569 6.26557H10.8392C10.8798 6.57766 10.9052 6.88338 10.9155 7.18272C10.9256 7.48192 10.9307 7.76903 10.9307 8.04405C10.9307 8.31907 10.9256 8.59886 10.9155 8.8834C10.9052 9.16809 10.8798 9.45183 10.8392 9.73462ZM10.7261 5.1227H14.2577C13.7878 4.09587 13.1364 3.25191 12.3034 2.5908C11.4705 1.92984 10.5214 1.49452 9.45637 1.28485C9.73476 1.75255 9.98326 2.31585 10.2019 2.97476C10.4206 3.63352 10.5954 4.3495 10.7261 5.1227ZM6.50952 5.1227H9.56977C9.40963 4.22657 9.18955 3.41389 8.90955 2.68465C8.6294 1.95541 8.33943 1.45503 8.03965 1.18353C7.73986 1.45503 7.44989 1.95541 7.16974 2.68465C6.88974 3.41389 6.66967 4.22657 6.50952 5.1227ZM1.82155 5.1227H5.35324C5.48394 4.3495 5.65866 3.63352 5.87742 2.97476C6.09603 2.31585 6.34453 1.75255 6.62293 1.28485C5.55214 1.49452 4.60173 1.93131 3.77168 2.5952C2.94149 3.25894 2.29145 4.10144 1.82155 5.1227Z"
                            fill="#696969" />
                    </g>
                    <defs>
                        <clipPath id="clip0_848_24018">
                            <rect width="16" height="16" fill="white" transform="translate(0.0400391)" />
                        </clipPath>
                    </defs>
                </svg>
                <h4 class="nxp-review-title">Idiomas</h4>
            </div>

            <button class="nxp-review-title-action" type="button" @click="navigateToSelectedStep">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path
                        d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
                        fill="#4F4F4F" />
                </svg>
                Editar
            </button>
        </div>
        <hr class="custom-hr my-2 mb-4" />

        <div v-if="show()" class="flex flex-col px-6">
            <div class="flex flex-col space-y-1 py-4" v-for="(item, index) in languages"
                :key="`language-detail-${index}`">
                <p class="nxp-review-experiencies-title">
                    <b>
                        {{ item.name.split(" ").slice(0, -1).join(" ") }}
                    </b>
                </p>
                <p class="nxp-review-experiencies-subtitle">
                    {{ item.name.split(" ").slice(-1)[0] }}
                </p>

                <div v-if="languages.length > (index + 1)" class="flex w-full h-4"></div>
                <hr v-if="languages.length > (index + 1)" class="custom-hr" />
            </div>
        </div>
        <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
            <p class="nxp-review-no-data-text">
                Adicione os idiomas que você fala para completar seu perfil
            </p>
            <button class="nxp-review-no-data-btn" type="button" @click="navigateToSelectedStep">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path
                        d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
                        fill="#4F4F4F" />
                </svg>
                Adicionar Idiomas
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard'

export default {
    name: 'simple-languages',
    computed: {
        ...mapState('language', ['languages']),
        ...mapState('company', ['company']),

        color() {
            return this.company.base_hexcolor || '#1551b1'
        }
    },
    methods: {
        navigateToSelectedStep() {
            this.updateCurrentStep({ order: 4 })
            this.$router.push({ name: 'step-languages' })
        },

        formatTitle(title) {
            let _title = '';
            let splited = title.split(' ');

            splited.pop();

            splited.forEach(item => {
                if (_title === '') {
                    _title = item;
                } else {
                    _title = _title + ' ' + item;
                }
            })
            return _title;
        },

        show() {
            return this.languages.length > 0
        },
        ...mapActions('step', ['updateCurrentStep'])
    },

    components: {
        EmptyDetailCard
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/resume/simple.scss";
@import '@/assets/scss/talent/components/languagedetailcard.scss';

hr {
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
}
</style>